export default __webpack_public_path__ + "static/media/feature-box-collection-colonialism-550x310.ac5e3535.jpg";